var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
export var KeyboardShortcut = function (_a) {
    var shortcut = _a.shortcut, rest = __rest(_a, ["shortcut"]);
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        shortcut === false)
        return null;
    var macOS = window.navigator.platform.toUpperCase().includes('MAC');
    var modKey = macOS ? '⌘' : 'Ctrl';
    var displayedShortcut = shortcut === true
        ? "".concat(modKey, "+k")
        : Array.isArray(shortcut)
            ? shortcut[0].replace('mod', modKey)
            : shortcut.replace('mod', modKey);
    return (_jsx(Shortcut, __assign({ "aria-hidden": "true" }, rest, { children: displayedShortcut })));
};
var Shortcut = styled('kbd')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0, 0.5),
        borderRadius: 7,
        letterSpacing: '0px',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        opacity: 0.5,
        color: 'inherit',
        border: '1px solid',
    });
});
